export interface StatementFile {
    id: number,
    month: number,
    year: number,
    filename: string
}

export interface Statement {
    id: number;
    number: string;
    type: StatementType,
    date: string;
    dueDate: string;
    overdue: boolean;
    subtotal: number;
    tax: number;
    grandtotal: number;
    endingBalance: number;
    paymentStatus: StatementPaymentStatus;
}

export interface StatementSummary {
    currencyCode: string;
    balance: number;
    freeBalance: number;
    invoicesBalance: number;
    creditInvoicesBalance: number;
    onDate: string;
}

export enum StatementPaymentStatus {
     AWAITING = 'awaiting',
     PAID = 'paid',
     OVERPAID = 'overpaid',
     OVERDUE = 'overdue',
}

export enum StatementType {
    INVOICE = 'merged_invoice',
    CREDIT_INVOICE = 'credit_invoice'
}